<template>
  <div
    class="bg-gray-100 font-opensans border-b border-gray-300 rounded-md grid grid-cols-3 grid-rows-3-auto gap-2 py-4 mb-4"
    :class="{
      'bg-gray-100': !highlight,
      'bg-gray-200': highlight
    }"
  >
    <div class="col-span-3">
      <table :id="item.id" class="w-full ml-2">
        <tr>
          <th class="table-header-group font-semibold pr-2 w-1/4">Melding</th>
          <td class="table-cell pl-2 w-3/4">
            {{ item.created_string }}
          </td>
        </tr>

        <tr v-if="!edit_mode">
          <th class="table-header-group font-semibold pr-2 w-2">Titel</th>
          <td class="table-cell pl-2">{{ item.title }}</td>
        </tr>
        <tr v-if="hasPermission('read other users') && !edit_mode">
          <th class="table-header-group font-semibold pr-2 w-1/4">
            Uitvoerder
          </th>
          <td class="table-cell pl-2 w-3/4">{{ getUser(item.actor) }}</td>
        </tr>
        <tr
          v-if="
            !item.finished_string &&
              item.deadline_string &&
              hasPermission('update todoitem') &&
              !edit_mode
          "
        >
          <th class="table-header-group font-semibold pr-2 w-1/4">Deadline</th>
          <td class="table-cell pl-2 w-3/4">{{ item.deadline_string }}</td>
        </tr>
        <tr v-if="!edit_mode">
          <th class="table-header-group font-semibold pr-2 w-2">Opmerking</th>
          <td class="table-cell pl-2">{{ item.description }}</td>
        </tr>
        <tr v-if="edit_mode" class="w-full">
          <td colspan="2">
            <FeedbackForm
              mode="update"
              :id="item.id"
              v-on:feedbackSuccesfullySaved="
                edit_mode = false;
                msg = 'Gegevens succesvol opgeslagen.';
              "
            />
          </td>
        </tr>
        <tr v-if="item.finished_string">
          <th class="table-header-group font-semibold pr-2">Afgerond op</th>
          <td class="table-cell pl-2">
            {{ item.finished_string }}
          </td>
        </tr>
      </table>

      <p class="text-red-600 ml-4 mb-2 mt-0" v-if="msg">{{ msg }}</p>
    </div>

    <button
      v-if="canFinishFeedback(item)"
      @click="finishItem(item.id)"
      :disabled="edit_mode"
      class="px-4 pt-4 bg-transparent border-transparent hover:text-gray-500 font-semibold hover:text-white border hover:border-transparent rounded"
      :class="{
        'text-gray-500': edit_mode,
        'text-green-500': !edit_mode
      }"
    >
      <i class="material-icons cursor-pointer">done</i>
    </button>

    <button
      v-if="canFinishFeedback(item)"
      @click="edit_mode = !edit_mode"
      class="px-4 pt-4 bg-transparent border-transparent hover:text-gray-500 text-mi-blue-400 font-semibold hover:text-white border hover:border-transparent rounded"
    >
      <i class="material-icons cursor-pointer">{{
        edit_mode ? "edit_off" : "edit"
      }}</i>
    </button>

    <button
      v-if="canDeleteFeedback(item) & edit_mode"
      @click="showRemove = true"
      class="px-4 pt-4 bg-transparent border-transparent hover:text-red-800 text-red-600 font-semibold hover:text-white border hover:border-transparent rounded"
    >
      <i class="material-icons cursor-pointer">delete_outline</i>
    </button>

    <div v-if="showRemove" class="col-span-3 lg:justify-self-end">
      <button
        @click="deleteItem(item.id)"
        class="bg-gray-100  text-red-700 font-semibold py-1 px-2 border border-red-600 rounded hover:bg-red-600 hover:text-white hover:border-transparent"
      >
        Ja, ik wil deze opmerking verwijderen
      </button>
      <button @click="showRemove = false">
        <i class="material-icons text-gray-500 hover:text-red-600">close</i>
      </button>
    </div>
  </div>
</template>

<script>
import FeedbackForm from "./FeedbackForm";
export default {
  name: "FeedbackList",
  props: ["item", "highlight"],
  components: {
    FeedbackForm
  },
  data() {
    return {
      edit_mode: false,
      msg: "",
      showRemove: false
    };
  },
  methods: {
    canDeleteFeedback: function(feedbackItem) {
      return (
        !feedbackItem.finished &&
        (feedbackItem.creator === this.$store.getters.current_user.id) |
          this.hasPermission("update todoitem of all users")
      );
    },
    getUser: function(uuid) {
      return this.$store.state.backend_data.users.find(user => user.id === uuid)
        .email;
    },
    canFinishFeedback: function(feedbackItem) {
      return (
        !feedbackItem.finished &&
        (feedbackItem.actor === this.$store.getters.current_user.id) |
          this.hasPermission("update todoitem of all users")
      );
    },
    finishItem: async function(id) {
      await this.$store.dispatch("finishFeedbackItem", id);
      this.$store.dispatch("loadFeedbackByObject", {
        objectname: this.$route.name.toLowerCase(),
        id: this.objectid
      });
    },
    deleteItem: function(id) {
      this.$store.dispatch("deleteFeedbackItem", id);
    },
    hideMsg: function() {
      this.msg = "";
    }
  },
  watch: {
    msg() {
      if (this.msg) {
        setTimeout(this.hideMsg, 5000);
      }
    }
  },
  mounted() {
    if (this.$route.hash.substr(1) === this.item.id) {
      this.$el.scrollIntoView();
    }
  }
};
</script>
